import React from 'react';
import { motion } from 'framer-motion';
import { Smartphone, Brain, Frown } from 'lucide-react';
export function ProblemSection() {
  const painPoints = [{
    icon: <Smartphone className="h-8 w-8 text-[#F97316]" data-id="element-96" />,
    text: 'Pasa horas en el teléfono pero no puede concentrarse 20 minutos en una tarea',
    delay: 0.1
  }, {
    icon: <Brain className="h-8 w-8 text-[#2B7FD4]" data-id="element-97" />,
    text: 'Tiene inteligencia pero el algoritmo le roba la dopamina antes de que pueda usarla',
    delay: 0.2
  }, {
    icon: <Frown className="h-8 w-8 text-[#1B3A6B]" data-id="element-98" />,
    text: 'Irritable, distraído, sin hobbies reales — y los castigos no cambian nada',
    delay: 0.3
  }];
  return <section className="py-20 bg-white relative overflow-hidden" data-id="element-99">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8" data-id="element-100">
        <div className="max-w-3xl mx-auto text-center mb-16" data-id="element-101">
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-3xl sm:text-4xl font-bold text-[#1B3A6B] mb-6 uppercase" data-id="element-102">
            Tu hijo no es el problema.{' '}
            <span className="text-[#F97316]" data-id="element-103">
              El algoritmo es el depredador.
            </span>
          </motion.h2>

          <motion.p initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.1
        }} className="text-lg text-slate-600 leading-relaxed" data-id="element-104">
            Sabes que tu hijo tiene el potencial para ser un líder, pero hoy su
            atención está fragmentada en clips de 15 segundos. No es un libro de
            quejas sobre la tecnología; es un sistema de entrenamiento mental
            diseñado para la generación que lo tiene todo a un click, pero nada
            en su autodisciplina. En 21 días, convertiremos esa energía dispersa
            en un enfoque inquebrantable.
          </motion.p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-105">
          {painPoints.map((point, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: point.delay
        }} className="bg-[#F8FAFC] p-8 rounded-2xl border border-slate-100 shadow-sm hover:shadow-md transition-shadow duration-300 flex flex-col items-center text-center group" data-id="element-106">
              <div className="mb-6 p-4 bg-white rounded-full shadow-sm group-hover:scale-110 transition-transform duration-300" data-id="element-107">
                {point.icon}
              </div>
              <p className="text-lg font-medium text-slate-800 leading-snug" data-id="element-108">
                {point.text}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}